import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { JhiLanguageService } from '../../../shared/core-utils';
import { Lot } from '../../../shared/inventory/model/lot.model';
import { finalize } from 'rxjs/operators';
import { Transaction } from '../../../shared/inventory/model/transaction.model';
import { TransactionService } from '../../../shared/inventory/service/transaction.service';
import { AlertService } from '../../../shared/alert/alert.service';

@Component({
    selector: 'jhi-transaction',
    templateUrl: './transaction.component.html',
})
export class TransactionComponent implements OnInit {

    readonly itemsPerPage: number = 10;

    transactions: Transaction[];

    @Input() gid: number;
    @Input() lotId: number;

    page: number;
    previousPage: number;
    totalItems: number;
    queryCount: number;
    predicate: string;
    reverse: boolean;

    isLoading: boolean;

    constructor(private activatedRoute: ActivatedRoute,
                private transactionService: TransactionService,
                private alertService: AlertService,
                private jhiLanguageService: JhiLanguageService,
                private router: Router
    ) {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        if (queryParams.gid) {
            this.gid = queryParams.gid;
        }
        if (queryParams.lotId) {
            this.lotId = queryParams.lotId;
        }
        this.page = 1;
        this.predicate = 'transactionId';
        this.reverse = false;
    }

    ngOnInit(): void {
        this.loadAll();
    }

    private loadAll() {
        this.isLoading = true;
        this.transactionService.getTransactionsByGermplasmId(this.gid, this.lotId, {
            lotStatus: 'ACTIVE',
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            (res: HttpResponse<Transaction[]>) => this.onSuccess(res.body, res.headers)
        );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['./'], {
            queryParams:
                {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                },
            relativeTo: this.activatedRoute,
            queryParamsHandling: 'merge'
        });
        this.loadAll();
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'transactionId') {
            result.push('transactionId');
        }
        return result;
    }

    private onSuccess(data: Transaction[], headers) {
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.transactions = data;
    }

    trackId(index: number, item: Lot) {
        return item.lotId;
    }

}
